module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesNatural.925e268.jpg";